import React from 'react';

function SearchBar({ value, onChange }) {
  return (
    <div className="search">
      <input
        type="text"
        placeholder="Search for essentials"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export default SearchBar;
